import {type User} from '../users/state'

export interface CurrentUserReduxState {
    isFetching: boolean
    currentUser: UserData
}

export type UserData = User

export const DEFAULT_USER_DATA = {
    user: '',
    username: '',
    email: '',
    emailNotificationEnabled: false,
    active: false,
    deleted: false,
    internalUser: false,
    roles: [],
    assignedTag: undefined,
    strictMode: undefined,
    notificationEmail: undefined,
    external: true,
}

export const DEFAULT_CURRENT_USER_STATE: CurrentUserReduxState = {
    isFetching: true,
    currentUser: DEFAULT_USER_DATA,
}
